"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Metaform REST API
 * REST API for Metaform
 *
 * The version of the OpenAPI document: 2.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
function MetaformFieldPermissionContextsFromJSON(json) {
    return MetaformFieldPermissionContextsFromJSONTyped(json, false);
}
exports.MetaformFieldPermissionContextsFromJSON = MetaformFieldPermissionContextsFromJSON;
function MetaformFieldPermissionContextsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'viewGroup': !runtime_1.exists(json, 'view-group') ? undefined : json['view-group'],
        'editGroup': !runtime_1.exists(json, 'edit-group') ? undefined : json['edit-group'],
        'notifyGroup': !runtime_1.exists(json, 'notify-group') ? undefined : json['notify-group'],
    };
}
exports.MetaformFieldPermissionContextsFromJSONTyped = MetaformFieldPermissionContextsFromJSONTyped;
function MetaformFieldPermissionContextsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'view-group': value.viewGroup,
        'edit-group': value.editGroup,
        'notify-group': value.notifyGroup,
    };
}
exports.MetaformFieldPermissionContextsToJSON = MetaformFieldPermissionContextsToJSON;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWV0YWZvcm1GaWVsZFBlcm1pc3Npb25Db250ZXh0cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9nZW5lcmF0ZWQvY2xpZW50L21vZGVscy9NZXRhZm9ybUZpZWxkUGVybWlzc2lvbkNvbnRleHRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxvQkFBb0I7QUFDcEIsb0JBQW9CO0FBQ3BCOzs7Ozs7Ozs7O0dBVUc7O0FBRUgsd0NBQStDO0FBMkIvQyxTQUFnQix1Q0FBdUMsQ0FBQyxJQUFTO0lBQzdELE9BQU8sNENBQTRDLENBQUMsSUFBSSxFQUFFLEtBQUssQ0FBQyxDQUFDO0FBQ3JFLENBQUM7QUFGRCwwRkFFQztBQUVELFNBQWdCLDRDQUE0QyxDQUFDLElBQVMsRUFBRSxtQkFBNEI7SUFDaEcsSUFBSSxDQUFDLElBQUksS0FBSyxTQUFTLENBQUMsSUFBSSxDQUFDLElBQUksS0FBSyxJQUFJLENBQUMsRUFBRTtRQUN6QyxPQUFPLElBQUksQ0FBQztLQUNmO0lBQ0QsT0FBTztRQUVILFdBQVcsRUFBRSxDQUFDLGdCQUFNLENBQUMsSUFBSSxFQUFFLFlBQVksQ0FBQyxDQUFDLENBQUMsQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxZQUFZLENBQUM7UUFDekUsV0FBVyxFQUFFLENBQUMsZ0JBQU0sQ0FBQyxJQUFJLEVBQUUsWUFBWSxDQUFDLENBQUMsQ0FBQyxDQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLFlBQVksQ0FBQztRQUN6RSxhQUFhLEVBQUUsQ0FBQyxnQkFBTSxDQUFDLElBQUksRUFBRSxjQUFjLENBQUMsQ0FBQyxDQUFDLENBQUMsU0FBUyxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsY0FBYyxDQUFDO0tBQ2xGLENBQUM7QUFDTixDQUFDO0FBVkQsb0dBVUM7QUFFRCxTQUFnQixxQ0FBcUMsQ0FBQyxLQUE4QztJQUNoRyxJQUFJLEtBQUssS0FBSyxTQUFTLEVBQUU7UUFDckIsT0FBTyxTQUFTLENBQUM7S0FDcEI7SUFDRCxJQUFJLEtBQUssS0FBSyxJQUFJLEVBQUU7UUFDaEIsT0FBTyxJQUFJLENBQUM7S0FDZjtJQUNELE9BQU87UUFFSCxZQUFZLEVBQUUsS0FBSyxDQUFDLFNBQVM7UUFDN0IsWUFBWSxFQUFFLEtBQUssQ0FBQyxTQUFTO1FBQzdCLGNBQWMsRUFBRSxLQUFLLENBQUMsV0FBVztLQUNwQyxDQUFDO0FBQ04sQ0FBQztBQWJELHNGQWFDIn0=